export default __webpack_public_path__ + "static/rozen-7b66bc3787553d28e28a7990aa7c7889.jpg";